import React, { PropsWithChildren } from 'react';

import styles from './styles.css';

export const ScreenReaderOnly: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles['sr-only']}>{children}</div>;
};
